export default {
	"delivery.ThereIsNoLogisticalInformation": "There is no logistical information",
	"delivery.ParameterError": "Parameter error!"
}